import { render } from "./ClaimStep1.vue?vue&type=template&id=5f40f8cc&ts=true"
import script from "./ClaimStep1.vue?vue&type=script&lang=ts"
export * from "./ClaimStep1.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__